import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component4cards from '../components/component4cards'
import FooterMain from '../components/footer-main'
import './founder.css'

const IgorMushnikov = (props) => {
  return (
    <div className="founder-container">
      <Helmet>
        <title>Мушников Игорь — CTO Arcobo</title>
        <meta
          name="description"
          content="Мушников Игорь — CTO Arcobo. Более 15 лет в области высоких технологий: промышленная робототехника, R&D и автоматизация производства."
        />
        <meta
          property="og:title"
          content="Мушников Игорь — CTO Arcobo"
        />
        <meta
          property="og:description"
          content="Мушников Игорь — CTO Arcobo: электроника, промышленные роботы, программирование и автоматизация производства."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="profile" />
        <meta
          name="twitter:title"
          content="Мушников Игорь — CTO Arcobo"
        />
        <meta
          name="twitter:description"
          content="Мушников Игорь — CTO Arcobo: электроника, промышленные роботы, программирование и автоматизация производства."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/igor-mushnikov"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/igor-mushnikov"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Igor Mushnikov","item":"https://arcobo.tech/igor-mushnikov"}]}',
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"Person","name":"Мушников Игорь","givenName":"Игорь","familyName":"Мушников","jobTitle":"CTO","worksFor":{"@type":"Organization","name":"Arcobo","url":"https://arcobo.tech"},"url":"https://arcobo.tech/igor-mushnikov","sameAs":"https://www.linkedin.com/in/mushnikoviv"}',
          }}
        />
      </Helmet>
      <HeaderMain></HeaderMain>
      <Componenttextimage
        image1Src="/4_Company Arcobo/4_5_Service/service%20main-1500w.webp"
        image1Alt="Мушников Игорь — CTO Arcobo"
        textComponent={
          <Fragment>
            <span className="founder-role">CTO</span>
            <br></br>
            <br></br>
            <span className="founder-text">
              <span>
                Основатель и технический директор ТОО «Аркобо». Более 15 лет
                опыта в области высоких технологий, из них 10 лет в научных
                исследованиях и разработках.
              </span>
              <br></br>
              <br></br>
              <span>
                10 лет в промышленной робототехнике и автоматизации
                производств. Сертифицирован корпорацией Kawasaki Robotics на
                интеграцию и сервисное обслуживание промышленных роботов.
              </span>
              <br></br>
              <br></br>
              <span>
                Руководит командой создания MES-системы, разрабатывает
                уникальные программные решения и отвечает за
                технологическое развитие продуктов Arcobo — от
                роботизированных комплексов до локализации и внедрения
                систем мониторинга сварочных процессов.
              </span>
              <br></br>
              <br></br>
              <span>
                Ведёт образовательное направление: обучает студентов и
                инженерный персонал предприятий работе с промышленными
                роботами и современными производственными технологиями.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Мушников Игорь"
      ></Componenttextimage>
      <Component4cards
        title1="Инжиниринг и R&D"
        title2="Разработка продуктов"
        title3="Электроника и роботы"
        title4="Обучение персонала"
        heading1="Направления ответственности"
        imageSrc="/Founders/icons/rnd-200w.webp"
        imageAlt="Инжиниринг и R&D"
        imageSrc1="/Founders/icons/product-200w.webp"
        imageAlt1="Разработка продуктов"
        imageSrc2="/Founders/icons/robot-200w.webp"
        imageAlt2="Электроника и роботы"
        imageSrc3="/Founders/icons/education-200w.webp"
        imageAlt3="Обучение персонала"
        description1="Научные исследования и разработка уникальных программных решений для автоматизации производства"
        description2="Руководит командой создания MES-системы и продуктами Arcobo: роботизированные комплексы, WAAM-печать, Welding Monitor"
        description3="Сертифицирован Kawasaki Robotics на интеграцию и сервисное обслуживание промышленных роботов"
        description4="Обучение студентов и инженерного персонала предприятий работе с робототехникой"
      ></Component4cards>
      <div className="founder-sections">
        <div className="founder-section">
          <h2 className="H1_medium">Опыт</h2>
          <div className="founder-block">
            <h3>Arcobo — Алматы</h3>
            <p className="founder-muted">
              С 2022 года · основатель и технический директор ТОО «Аркобо»
            </p>
            <p className="text_medium">
              Руководит разработкой собственных продуктов: MES-система,
              программное обеспечение роботизированных комплексов, WAAM-печать
              металлом, система мониторинга сварочных процессов Welding
              Monitor. Сертифицирован корпорацией Kawasaki Robotics на
              интеграцию и сервисное обслуживание промышленных роботов.
            </p>
          </div>
          <div className="founder-block">
            <h3>СПбПУ Петра Великого — Санкт-Петербург</h3>
            <p className="founder-muted">
              Инженер и аспирант · лаборатория лёгких материалов и
              конструкций
            </p>
            <p className="text_medium">
              Прикладные исследования в области технологий соединения лёгких
              материалов: дуговая и плазменная сварка, пайка, сварка трением
              с перемешиванием, электродуговое выращивание (WAAM).
            </p>
          </div>
        </div>
        <div className="founder-section">
          <h2 className="H1_medium">Образование</h2>
          <ul className="founder-list text_medium">
            <li>
              СПбПУ Петра Великого — бакалавр, техническая физика (2011–2015)
            </li>
            <li>
              СПбПУ Петра Великого — магистр, техническая физика (2015–2017)
            </li>
            <li>
              СПбПУ Петра Великого — аспирантура, физическая электроника
              (2017–2021)
            </li>
          </ul>
        </div>
        <div className="founder-section">
          <h2 className="H1_medium">Публикации и патенты</h2>
          <ul className="founder-list text_medium">
            <li>
              «The Coatings Breakdown Products Influence on the Gas Metal
              Arc Welding Parameters» — Coatings, MDPI (2020)
            </li>
            <li>
              «A high-performance WAAM process for Al–Mg–Mn using controlled
              short-circuiting metal transfer» — Materials &amp; Design,
              Elsevier (2020)
            </li>
            <li>
              «Comparison of porosity evaluation methods using the example
              of dissimilar metal joints» — Key Engineering Materials (2019)
            </li>
            <li>
              «Finite element simulation of temperature field during
              friction surfacing of Al-5Mg consumable rod» — Key Engineering
              Materials (2019)
            </li>
            <li>
              «Development of dissimilar metal joints porosity evaluation
              method» — MS&amp;T 2019, Materials Science and Technology
            </li>
            <li>
              6 патентов на изобретения в области сварки и аддитивных
              технологий; свидетельство на программу построения траектории
              сварочной горелки при электродуговом выращивании
            </li>
          </ul>
        </div>
      </div>
      <FooterMain></FooterMain>
    </div>
  )
}

export default IgorMushnikov
